import { backendAxios } from "../Services/axios";
import { iPaginationProps } from "../models/iPagination";

export default class PartnerController {
  static async requestPartnership(payload: any) {
    const response = await backendAxios.post("partner-request", { payload });
    return response.data;
  }

  static async getPaginated(params: iPaginationProps, onlyLive = false) {
    const response = await backendAxios.get("/partner/paginate", {
      params: {
        ...params,
        onlyLive: onlyLive ? true : null,
      },
    });
    return response.data;
  }
}
